import { makeApiCallWithAny } from "./tokenService";
import { WorkShiftDto } from "../models/workShift/workShift";

export const getWorkShifts = (
    startDate: string,
    endDate: string,
    withSlots = false,
    signal?: AbortSignal
): Promise<WorkShiftDto[]> => {
    return makeApiCallWithAny<WorkShiftDto[]>(
        `api/workshifts?startDate=${encodeURIComponent(
            startDate
        )}&endDate=${encodeURIComponent(endDate)}&withSlots=${withSlots}`,
        signal
    );
};

export const getCurrentWorkShift = async (
    withSlots = false,
    signal?: AbortSignal
): Promise<WorkShiftDto> => {
    const current = await makeApiCallWithAny<WorkShiftDto>(
        `api/workshift/current?withSlots=${withSlots}`,
        signal
    ).catch((e) => {
        if (e.code !== "404") {
            throw e;
        }
    });

    return current || null;
};
